import { render, staticRenderFns } from "./ChangeStateInPending.vue?vue&type=template&id=53d83e28"
import script from "./ChangeStateInPending.vue?vue&type=script&lang=js"
export * from "./ChangeStateInPending.vue?vue&type=script&lang=js"
import style0 from "./ChangeStateInPending.vue?vue&type=style&index=0&id=53d83e28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports